module.exports = __webpack_public_path__ + "img/Like.3e795071.svg";